/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrColumnSortDescription } from './igr-column-sort-description';
import { ColumnSortDescription } from './ColumnSortDescription';
import { TypeRegistrar } from "igniteui-react-core";
var IgrColumnSortDescriptionModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrColumnSortDescriptionModule() {
    }
    IgrColumnSortDescriptionModule.register = function () {
        TypeRegistrar.registerCons("IgrColumnSortDescription", IgrColumnSortDescription);
        TypeRegistrar.register("ColumnSortDescription", ColumnSortDescription.$type);
    };
    return IgrColumnSortDescriptionModule;
}());
export { IgrColumnSortDescriptionModule };
//# sourceMappingURL=igr-column-sort-description-module.js.map
